import React from 'react';
import { MasterLayout } from 'layout';
import { TongHopKetQua } from 'modules/thong-ke-bao-cao';

class KetQuaKiemTraChiTietDoanhNghiepPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='KIEM_TRA_CHI_TIET_DOANH_NGHIEP' />
      </MasterLayout>
    );
  }
}

export default KetQuaKiemTraChiTietDoanhNghiepPage;



// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/KetQuaKiemTraChiTietDoanhNghiep.jsx